import { WEB_FONTS } from '../strings';
import { DateTime } from 'luxon';
import { makeStyles } from "@material-ui/core/styles";

export const formatNumberWithCommas = (number: number | string): string => {
  console.log("Formatting number:", number);
  if (number === null || number === undefined || number === '') return '0';

  // Convert string to clean numeric form
  const num = typeof number === 'string'
    ? parseFloat(number.replace(/[^0-9.-]/g, '')) // removes $, commas, spaces
    : number;

  if (isNaN(num)) return '0';

  return num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};


export const getRotationDegrees = (
  prizeNumber: number,
  numberOfPrizes: number,
  randomDif = true
): number => {
  const degreesPerPrize = 360 / numberOfPrizes;

  const initialRotation = 90 + degreesPerPrize / 2;

  const randomDifference = (-1 + Math.random() * 2) * degreesPerPrize * 0.35;

  const perfectRotation =
    degreesPerPrize * (numberOfPrizes - prizeNumber) - initialRotation;

  const imperfectRotation =
    degreesPerPrize * (numberOfPrizes - prizeNumber) -
    initialRotation +
    randomDifference;

  const prizeRotation = randomDif ? imperfectRotation : perfectRotation;

  return numberOfPrizes - prizeNumber > numberOfPrizes / 2
    ? -360 + prizeRotation
    : prizeRotation;
};

export const clamp = (min: number, max: number, val: number): number =>
  Math.min(Math.max(min, +val), max);

export const isCustomFont = (font: string): boolean =>
  !!font && !WEB_FONTS.includes(font.toLowerCase());

export const getQuantity = (prizeMap: number[][]): number =>
  prizeMap.slice(-1)[0].slice(-1)[0] + 1;

const characters =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const makeClassKey = (length: number): string => {
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export const formatUTCToLocal = (utcString) => {
  return DateTime.fromISO(utcString, { zone: 'utc' })
    .toLocal()
    .toFormat('yyyy-MM-dd, hh:mm a');
};


export const getOrdinalSuffix = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const useBallStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  paperClass: {
    padding: "40px",
    textAlign: "center",
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
    boxSizing: "border-box",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: "25px",
    },
  },
  first: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: "100%",
    paddingBottom: "20px !important",
    [theme.breakpoints.down("sm")]: {
      minHeight: "295px",
      paddingBottom: "10px !important",
    },
  },
  second: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: 150,
  },
  parentPaper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 1600,
  },
  availableTickets: {
    border: "0.5px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "10px",
    height: 76,
    [theme.breakpoints.down("md")]: {
      height: "52px",
    },
  },
  noOfTickets: {
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
    marginBlock: "25px",
    [theme.breakpoints.down("md")]: {
      marginBlock: "20px",
    },
  },
  tableContainer: {
    background: "#050518",
    borderRadius: 8,
  },
  table: {
    minWidth: 650,
  },
  tableHeader: {
    color: "#fff",
    padding: "22px !important",
    [theme.breakpoints.down("lg")]: {
      padding: "18px !important",
    },
    [theme.breakpoints.down("md")]: {
      padding: "15px !important",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px !important",
    },
  },
  logoTable: {
    [theme.breakpoints.down("md")]: {
      height: "45px",
      width: "45px",
    },
  },
  tableData: {
    fontSize: "14px",
    color: "#fff",
    opacity: "0.6",
    BorderBottom: "1px solid #0D0D39",
  },
  minimumTicket: {
    background: "#3C37FF",
    borderRadius: "10px",
    color: "#fffff",
  },
  logo: {
    width: 50,
  },
  myGridItem: {
    // backgroundColor: "rgba(5, 5, 24, 0.8)",
    backgroundColor: "rgb(75 75 75 / 80%)",
    padding: "30px",
    [theme.breakpoints.down("md")]: {
      padding: "10px !important",
    },
    [theme.breakpoints.up("md")]: {
      padding: "30px !important",
    },
    borderRadius: "20px",
  },
  innerGrid: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      padding: "0px !important",
    },
  },
  innerGridFirst: {
    backgroundRepeat: "no-repeat",
    height: "auto",
    width: "auto",
    maxHeight: "282px",
    borderRadius: "20px",
    maxWidth: "100%",
    marginInline: "auto",
    backgroundPosition: "left bottom",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.down("md")]: {
      borderRadius: "10px",
    },
  },
  substract: {
    border: "1px solid #ffff !important",
    borderRadius: "10px !important",
    color: "#ffff",
  },
  innerGridSecond: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
    [theme.breakpoints.down("md")]: {
      padding: "7px",
    },
  },
  ticketPrize: {
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
    padding: "30px",
    [theme.breakpoints.down("md")]: {
      padding: "5px 10px",
    },
  },

  ballContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: theme.spacing(1),
  },
  cardContent: {
    position: "relative",
    padding: theme.spacing(2),
  },
  ballRow: {
    display: "flex", 
    flexWrap: "wrap",
    margin: theme.spacing(-1),
  },
  ball: {
    minWidth: 30, // Adjust width of the ball
    minHeight: 30, // Adjust height of the ball
    maxWidth:"40px",
    [theme.breakpoints.down("sm")]: {
      minWidth: 20, // Adjust width of the ball
      minHeight: 20, // Adjust height of the ball
      maxWidth:"20px",
    },
    fontSize: 11, // Adjust font size of the ball number
    padding:"5px",
    aspectRatio: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    borderRadius: "50%",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
    margin: theme.spacing(-0.5),
    backgroundImage: (props: any) =>
      `linear-gradient(135deg, ${props.color} 30%, ${props.colorDark} 90%)`,
    transition: "transform 0.3s ease-in-out", // Transition for animation
    "&:hover": {
      transform: "scale(1.9)", // Scale up on hover
    },
  },
  selectedBall: {
    transform: "scale(2.0)",
    border: "2px solid white",
    "@media screen and (max-width:992px)": {
      transform: "scale(1.5)",
    },
  },
  ballText: {
    marginTop: theme.spacing(1),
    fontSize: 12,
  },

  checkboxLabel: {
    fontSize: "12px",
    color: "#ffffff",
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
      fill: "#ffffff",
    },
    "& .MuiTypography-body1": {
      fontSize: "12px",
    },
  },
}));

export const shortenString = (str, startCount = 3, endCount = 3) => {
  if (!str || str.length <= startCount + endCount) return str;
  return `${str.slice(0, startCount)}...${str.slice(-endCount)}`;
};